<template>
  <div>

    <!-- Step 1 modal -->
    <v-dialog persistent :value="addModal" width="800">
      <popup-heading 
      :title="showPin ? 'Personal Pin' : 'Invite A User'" 
      :subtitle="showPin ? 'Allow user to login using their personal pin' : 'Invite a user to join our organization'">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
          <v-btn
            depressed
            v-if="showPin"
            @click="addPin()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>

      <!--- Step 1-->
      <v-card class="elevation-0">
        <v-layout  justify-center>
            <v-flex class="sm12 md8 lg8">
              <v-card class="elevation-0" >
                <v-card-text>
                  <v-form v-if="showPin" ref="pinForm" lazy-validation>
                    <v-flex xs12>
                      <v-text-field
                        v-model="user.pin"
                        :rules="showPin ? fieldRequired : []"
                        label="Pin"
                        type="number"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        v-model="user.confirm_pin"
                        :rules="showPin ? pinConfirmationRules : []"
                        label="Confirm Pin"
                        type="number"
                      ></v-text-field>
                    </v-flex>

                  </v-form>

                  <v-form v-else ref="inviteForm" lazy-validation>
                    <v-flex xs12>
                      <v-text-field
                          v-model="form.first_name"
                          prepend-icon="fas fa-user-circle"
                          :rules="fieldRequired"
                          label="First Name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.last_name"
                          prepend-icon="fas fa-user-circle"
                          :rules="fieldRequired"
                          label="Last Name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.email"
                          prepend-icon="fas fa-envelope"
                          :rules="emailRules"
                          label="Email"
                          autocomplete="off"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.password"
                          :rules="passwordRules"
                          prepend-icon="fas fa-lock"
                          name="password"
                          label="Password"
                          id="password"
                          autocomplete="off"
                          validate-on-blur
                          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.confirm_password"
                          :rules="passwordConfirmationRules"
                          prepend-icon="fas fa-lock"
                          name="Confirm password"
                          label="Confirm password"
                          id="confirm_password"
                          autocomplete="off"
                          validate-on-blur
                          :append-icon="showConfirmPassword ? 'visibility_off' : 'visibility'"
                          :type="showConfirmPassword ? 'text' : 'password'"
                          @click:append="showConfirmPassword = !showConfirmPassword"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox 
                          class="xl"
                          color="primary"
                          v-model="form.reset_password"
                          label="User must create new password on first log in"
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12>
                        <v-checkbox 
                          class="xl"
                          color="primary"
                          v-model="form.send_invitation"
                          label="Send an invitation email to the user. If not checked, you will need to provide the user with the details for their account manually."
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12>
                       <v-select
                        v-if="$store.getters.is_unoapp"
                        prepend-icon="fas fa-mouse-pointer"
                        v-model="form.type"
                        :items="['client', 'unoapp']"
                        label="Type"
                      ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox 
                          class="xl"
                          color="primary"
                          v-model="form.corporate"
                          label="Add as a Corporate user. By checking this box, this user will have access to top level organization settings and communications."
                        ></v-checkbox>
                      </v-flex>
                    </v-form>

                </v-card-text>
              </v-card>
              <!--- Step 1 ends -->
          </v-flex>
        </v-layout>
        

        <!-- Setp actions -->
        <div class="px-3 pb-3 text-xs-left text-md-right">
          <v-btn
            depressed
            v-if="!showPin"
            color="primary"
            fab
            medium
            @click="inviteUser()"
          >
            <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
          </v-btn>
        </div>
        <!-- Setp actions ends -->
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(v) || 'Password must have 1 capital, 1 number, 1 special letter and more than 8 characters',
      ],
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      showPin: false,
      showPassword: false,
      showConfirmPassword: false,
      user: {
        id: '',
        pin: '',
        confirm_pin: '',
      },
      form: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        reset_password: false,
        type: '',
        send_invitation: false,
        corporate: false,
      },
    };
  },
  computed: {
    pinConfirmationRules() {
      return [
        () => (this.user.pin === this.user.confirm_pin) || 'Pin Mismatch',
        v => !! v || 'Pin confirmation is required'
      ];
    },
    passwordConfirmationRules() {
      return [
        () => (this.password === this.confirm_password) || 'Password Mismatch',
        v => !! v || 'Password confirmation is required'
      ];
    },
    addModal() {
      return this.addModal;
    },
    ...mapGetters({
      apps: 'application/list',
      addModal: 'user/add',
    }),
  },
  mounted() {
    if(this.addModal){
      this.closeModal();
    }
    this.fetchApps();
  },
  methods: {
    
    /**
     * Fetch all apps if not fetched
     */
    fetchApps() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}/apps`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setAppList(res.data.payload);
      })
      .catch(() => {
        console.log('error getting applications')
      });
    },

    /**
     * Add pin 
     */

    addPin() {
      if (this.$refs.pinForm.validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/users/pins`;
        AuthApi.postApi(url, {
          user_id: parseInt(this.user.id), 
          pin: parseInt(this.user.pin), 
          confirm_pin: parseInt(this.user.confirm_pin), 
        })
        .then((res) => {
          this.$refs.pinForm.reset();
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
          this.closeModal();
          this.spinner(false);
        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
        });
      }
    },
    /**
     * Add new user and invite
     */
    inviteUser() {

      if (this.$refs.inviteForm.validate()) {
        this.spinner(true);
        // Manage request
        let data = {};
        for(let key in this.form){
          data[key] = this.form[key];
        }
        if(!this.$store.getters.is_unoapp){
           delete data['type']; 
        }
        const url = `${Env.url}/api/v1/users/businesses/invite`;
        AuthApi.postApi(url, data)
          .then((res) => {
            this.getAllUsersForBusiness();
            this.spinner(false);
            this.snackbar({
              text: res.data.msg,
              timeout: 4000,
              open: true,
            });
            // Check if  business has access to the application: io.unoapp.pos
            let hasBusinessApps = this.apps.filter(item => item.identifier === 'io.unoapp.pos');
            this.$refs.inviteForm.reset();
            if(hasBusinessApps.length > 0) {
              if(res.data.payload.invited_user.id && res.data.payload.invited_user.send_invitation === false){
                this.user.id = res.data.payload.invited_user.id;
                this.showPin = true;
                this.$refs.pinForm.resetValidation();
              } else {
               this.closeModal();
              }
            } else {
             this.closeModal();
            }
          })
          .catch((err) => {
            this.spinner(false);
            console.log('Unable to register user.')
          });
      }
    },

    /**
     * Get all users for business
     */
    getAllUsersForBusiness() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}/users`;
      AuthApi.getApi(url)
      .then((res) => {
        let rawdata = res.data.payload;
        rawdata.map(item => {
          if(item.status == 'active') {
            item.status_bool = true;
          } else {
            item.status_bool = false;
          }
        })
        this.setUserList(rawdata);
      })
      .catch((err) => {
        console.log(err.response.data.msg);
      });
    },
    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      // Rest form values
     if(this.showPin) {
      this.$refs.pinForm.reset();
     } else {
      this.$refs.inviteForm.reset();
     }
    
     
      // this.form.reset_password = false;
      // this.form.corporate = false;
      // this.form.send_invitation = false;
      this.showPin = false;
      this.addUserPopup(false);
      this.spinner(false);
    },

    ...mapActions({
      setAppList: 'application/setList',
      setUserList: 'user/setList',
      addUserPopup: 'user/setAdd',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
